import React from 'react';

import { Button, VStack } from '@chakra-ui/react';
import { MdLogout, MdSettings } from 'react-icons/md';
import { FaDiscord, FaRegCommentDots } from 'react-icons/fa';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '#contexts/auth';
import { t } from '#i18n';

const SETTINGS_PATH = '/settings';

const MenuButton = ({
  icon,
  label,
  onClick,
  isExternal = false,
}) => (
  <Button
    variant="ghost"
    width="full"
    borderRadius={0}
    justifyContent="flex-start"
    fontWeight="medium"
    leftIcon={icon}
    onClick={onClick}
    rightIcon={isExternal ? <ExternalLinkIcon opacity={0.2} /> : null}
  >
    {label}
  </Button>
);

export const AccountOptions = ({ ...props }) => {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <VStack {...props} width="full">
      <MenuButton
        icon={<FaRegCommentDots />}
        onClick={() => window.open(t('navmenu.feedback.url'), '_blank')}
        label={t('navmenu.feedback.title')}
        isExternal
      />
      <MenuButton
        icon={<FaDiscord />}
        onClick={() => window.open(t('navmenu.community.url'), '_blank')}
        label={t('navmenu.community.title')}
        isExternal
      />
      <MenuButton
        icon={<MdSettings />}
        onClick={() => navigate(SETTINGS_PATH)}
        label={t('common.settings')}
      />
      <MenuButton
        icon={<MdLogout />}
        onClick={() => signOut()}
        label={t('common.signOut')}
      />
    </VStack>
  );
};
